import { frontendURL } from '../../../helper/URLHelper';

const WhatsappTemplatesIndex = () =>
  import('./pages/WhatsappTemplatesIndex.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/whatsapp-templates'),
    name: 'whatsapp_templates_index',
    meta: {
      permissions: ['administrator', 'template_manage'],
    },
    component: WhatsappTemplatesIndex,
  },
  {
    path: frontendURL('accounts/:accountId/whatsapp-templates/inbox/:inbox_id'),
    name: 'whatsapp_templates_inbox',
    meta: {
      permissions: ['administrator', 'template_manage'],
    },
    component: WhatsappTemplatesIndex,
    props: route => ({ inboxId: route.params.inbox_id }),
  },
];
